<template>
  <a
    id="wh-widget-send-button"
    :href="`https://wa.me/${WHATSAPP_NUMBER}`"
    class="whatsapp-button"
    :class="{'mobile': isMobile}"
    target="_blank"
    v-if="visible">
    <i class="fa fa-whatsapp"></i>
  </a>
</template>

<script>
export default {
  name: 'WhatsappButton',
  data() {
    return {
      WHATSAPP_NUMBER: process.env.VUE_APP_WHATSAPP_NUMBER,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    visible() {
      let value = true;
      const route = this.$route;
      switch (route.name) {
        case 'affiliation':
          value = false;
          break;
        case 'createevent':
          value = false;
          break;
        default:
          value = true;
      }
      return value;
    },
  },
};
</script>

<style lang="scss">
  .whatsapp-button {
    position: fixed;
    width: 50px;
    height: 50px;
    bottom: 40px;
    right: 40px;
    background-color: #25d366;
    color: #FFF!important;
    border-radius: 50px;
    text-align: center;
    font-size: 30px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: rgba(136, 136, 136, 0.4) 0px 1px 7px;

    &.mobile {
      bottom: 15px;
      right: 15px;
    }
  }
</style>
